import { type ReactNode } from "react";
import { Icon } from "../../../common/components/icon/Icon";
import { IconType } from "../../../common/components/icon/IconType";
import { IconSize } from "../../../common/components/icon/IconSize";
import classNames from "classnames";
import LinearInfo from "./LinearInfo";
import LanguageAwareExternalContent from "./LanguageAwareExternalContent";
import { useConfiguratorType } from "~/Configurators/common/useConfiguratorType";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { Alert } from "~/common/m3/Alert/Alert";

interface Props {
  className?: string;
  title: string;
  csticIndex: number;
  csticAmount: number;
  children: ReactNode;
  info?: string;
  description?: string;
  isPicked: boolean;
  showError?: boolean;
  errorMessage: string;
}

const SubstepFrame = (props: Props) => {
  const { className, title, description, csticAmount, csticIndex, isPicked, showError, errorMessage, info } = props;

  const configuratorType = useConfiguratorType();
  const isOldConfigurator = configuratorType === ConfiguratorType.System;

  const externalContentCls = isOldConfigurator
    ? "scha__lc__external-content--shaft"
    : "scha__lc__external-content--shaft";

  return (
    <div className={classNames(className, "scha__linear-configurator__semi-steps__frame", isPicked && "picked")}>
      <div className="scha__linear-configurator__semi-steps__frame__count">
        <Icon className={"image-scale-up"} type={IconType.Check} size={IconSize.FONT_20} />
        <span className={"ml-2"}>
          {csticIndex}/{csticAmount}
        </span>
      </div>
      <h3 className="scha__linear-configurator__semi-steps__frame__title">
        <LanguageAwareExternalContent content={title} loadedClassname={"scha__lc__external-label"} />
        <LinearInfo info={info} popupClassName={externalContentCls} />
      </h3>
      {description && (
        <div className="mt-3">
          <LanguageAwareExternalContent content={description} loadedClassname={"scha__lc__external-label"} />
        </div>
      )}
      {showError && (
        <Alert className={"mt-30"} severity="error" data-message="error">
          {errorMessage}
        </Alert>
      )}
      <div className="mt-30 scha__linear-configurator__semi-steps__frame__tile">{props.children}</div>
    </div>
  );
};

export default SubstepFrame;
